import contact from '../../Assets/Images/contactBg.jpg'
import { HeaderOfPages, MiniContainer } from '../../Components';
import { ContactUsSec } from '../../Sections';
import './ContactPage.css'



const ContactPage = () => {
    return (
        <>        
            <HeaderOfPages
                contImg={contact}
                altImg="contact"
                title={<>Contact Us <br /> Your Feedback</>}
                impWord="Matters!"
            />

            <div className='contact-page'>
                <MiniContainer>
                    <ContactUsSec />
                </MiniContainer>
            </div>
        </>
    )
}

export default ContactPage